<template>

  <div class="applicant-outer">
    <!-- <i class="locumate_icons locumate_icon-users"></i> -->
    <div class="applicants">

      {{ filledSlots }} Applicants
    </div>

    <div class="slots-info">
      {{ filledSlots }} out of {{ totalSlots }}
    </div>
  </div>
  <div class="progress-bar-outer">
    <div class="progress-bar" :style="`--filled-count: ${filledSlots}; --total-slots: ${totalSlots}`"></div>
    <!-- <div class="progress-bar-inner" v-for="index in totalSlots" :key="index">
      <div class="progress-bar" :class="{ filled: index <= filledSlots }"></div>
    </div> -->
  </div>

</template>

<script>
export default {
  props: {
    totalSlots: {
      type: Number,
      default: 5,
    },
    filledSlots: {
      type: Number,
      default: 0,
    },
  },
};
</script>
